//import 'babel-polyfill'
import Vue from "vue";
import BootstrapVue from "bootstrap-vue";
import IdleVue from "idle-vue";
import App from "./App.vue";
import store from "./store";
import i18n from "./i18n";
import VueMeta from "vue-meta";
import vco from "v-click-outside";
import VueHotkey from "v-hotkey";
import VueSweetalert2 from "vue-sweetalert2";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import Toast from "vue-toastification";
import VueCropper from "vue-cropperjs";
import VueResize from "vue-resize";
import { AuthModule } from "../src/store/modules/auth.module";
import { SettingModule } from "../src/store/modules/settings.module";
import VueMask from "v-mask";
// global components
export const bus = new Vue();
import GlobalComponents from "./globalComponents";
import "vue-toastification/dist/index.css";
import "cropperjs/dist/cropper.css";
import "vue-resize/dist/vue-resize.css";
// router
import router from "./router";
// include all css files
import "./design/app.scss";
Vue.config.productionTip = false;
Vue.directive("focus", {
    inserted: function (el) {
        el.focus();
    },
});
Vue.directive("highlight", {
    bind(el, binding) {
        updateHighlight(el, binding);
    },
    update(el, binding) {
        updateHighlight(el, binding);
    },
});
function updateHighlight(el, binding) {
    const searchWord = binding.value.trim().replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    if (searchWord) {
        const regex = new RegExp(`(${searchWord})`, "gi");
        const originalContent = el.innerHTML;
        const tempDiv = document.createElement("div");
        tempDiv.innerHTML = originalContent;
        const highlightText = (node) => {
            if (node.nodeType === Node.TEXT_NODE) {
                let match;
                let lastIndex = 0;
                const parent = node.parentNode;
                const newNodes = [];
                while ((match = regex.exec(node.textContent)) !== null) {
                    const [matchedText] = match;
                    const index = match.index;
                    // Add text before the match
                    if (index > lastIndex) {
                        newNodes.push(document.createTextNode(node.textContent.substring(lastIndex, index)));
                    }
                    // Add the matched text wrapped in a <mark> element
                    newNodes.push(createHighlightElement(matchedText));
                    lastIndex = index + matchedText.length;
                }
                // Add any remaining text after the last match
                if (lastIndex < node.textContent.length) {
                    newNodes.push(document.createTextNode(node.textContent.substring(lastIndex)));
                }
                // Replace the original text node with the new nodes
                newNodes.forEach((newNode) => parent.insertBefore(newNode, node));
                parent.removeChild(node);
            }
            else if (node.nodeType === Node.ELEMENT_NODE) {
                Array.from(node.childNodes).forEach(highlightText);
            }
        };
        const createHighlightElement = (text) => {
            const mark = document.createElement("mark");
            mark.className = "search-highlight";
            mark.textContent = text;
            return mark;
        };
        highlightText(tempDiv);
        el.innerHTML = tempDiv.innerHTML;
    }
}
Vue.directive("rights", {
    inserted: function (el, node) {
        var right = node.value;
        var availabeRights = SettingModule.securityRights;
        if (availabeRights != null) {
            var hasRightExists = availabeRights.find((x) => x.id == right);
            if (hasRightExists != null) {
                el.hidden = false;
            }
            else {
                el.hidden = true;
            }
        }
    },
});
// navigation guards before each
router.beforeEach(async (to, from, next) => {
    if (to.matched.some((m) => !m.meta.publicPage) && !AuthModule.isAuthenticated) {
        // Secure Pages in an unauthenticated state
        if (to.fullPath != "/tenant-gateway") {
            localStorage.setItem("TenantGatewayRedirectRoute", to.fullPath);
        }
        AuthModule.Login().then(async (x) => {
            if (x === null || x === undefined) {
                next(false);
            }
            else {
                if (to.fullPath && to.fullPath.includes("/File/")) {
                    const parts = to.fullPath.split("/File/");
                    const uniqueIdentifier = parts[1];
                    await FileUploadModule.DownLoadFile(uniqueIdentifier).then((res) => {
                        if (res) {
                            setTimeout(() => {
                                window.close();
                            }, 3000);
                        }
                    });
                    next(false);
                }
                else {
                    if (to.matched.some((m) => !m.meta.tenantAgnostic) && (SettingModule.tenant === null || SettingModule.tenant === undefined)) {
                        localStorage.setItem("TenantGatewayRedirectRoute", to.fullPath);
                        next({ name: "TenantGateway" });
                    }
                    else {
                        next();
                    }
                }
            }
        });
    } // Public Pages (or) Secure pages in an Authenticated state
    else {
        if (to.fullPath && to.fullPath.includes("/File/")) {
            const parts = to.fullPath.split("/File/");
            const uniqueIdentifier = parts[1];
            await FileUploadModule.DownLoadFile(uniqueIdentifier).then((res) => {
                if (res) {
                    setTimeout(() => {
                        window.close();
                    }, 3000);
                }
            });
            next({ name: "DashBoard" });
        }
        else if (to.matched.some((m) => !m.meta.tenantAgnostic) && (SettingModule.tenant === null || SettingModule.tenant === undefined)) {
            localStorage.setItem("TenantGatewayRedirectRoute", to.fullPath);
            next({ name: "TenantGateway" });
        }
        else {
            next();
        }
    }
});
const eventsHub = new Vue();
export const APP_TIMEOUT_DURATION_IN_SECONDS = `${process.env.VUE_APP_TIMEOUT_DURATION_IN_SECONDS}`;
Vue.use(vco);
Vue.use(BootstrapVue);
Vue.use(GlobalComponents);
Vue.use(VueCropper);
Vue.use(VueMask);
Vue.use(IdleVue, {
    eventEmitter: eventsHub,
    store,
    idleTime: 3600000,
    startAtIdle: false,
});
Vue.use(VueMeta, {
    // The component option name that vue-meta looks for meta info on.
    keyName: "metaInfo",
});
Vue.use(VueHotkey);
Vue.use(VueSweetalert2);
// StateCharts.io Supplemental page that shows the state machine.
// inspect({
//     iframe: false,
// });
const toastOptions = {
    timeout: 5000,
};
Vue.use(Toast, toastOptions);
Vue.component("ValidationProvider", ValidationProvider);
Vue.component("ValidationObserver", ValidationObserver);
import "./types/validators";
import { FileUploadModule } from "./store/modules/fileUpload.module";
Vue.use(VueResize);
new Vue({
    router,
    store,
    i18n,
    render: (h) => h(App),
    components: { App },
}).$mount("#app");
